import { mqMin } from '../../breakpoints';
import type { Util } from '../../../types/util';

const sharedBase: Util.CSSProperties = {
  '&': {
    display: 'grid',
    maxWidth: '100%',
    ['[data-hero-role="heading"]']: { gridArea: 'heading' },
    ['[data-hero-role="subheading"]']: { gridArea: 'subheading' },
    ['[data-hero-role="link"]']: { gridArea: 'link', width: 'fit-content', display: 'inline-block', margin: 0 },
    ['[data-hero-role="image"]']: { gridArea: 'image' },
    ['[data-hero-role="text"]']: { gridArea: 'text' },
  },
};

const sharedStackedElements: Util.CSSProperties = {
  textAlign: 'center',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'repeat(5, auto)',
};

const topSubSharedStacked: Util.CSSProperties = {
  gridTemplateAreas: `
  "subheading"
  "image"
  "heading"
  "link"
  "text"
  `,
};

const base: Util.VariantCSSKeys<GridHeroVariantsType> = {
  loweredSub: {
    ...sharedBase,
    ...sharedStackedElements,
    gridTemplateAreas: `
    "heading"
    "image"
    "subheading"
    "link"
    "text"
    `,
    ['[data-hero-role="subheading"]']: { paddingTop: 's48' },
    ['[data-hero-role="link"]']: { margin: '0 auto' },
    ['[data-hero-role="text"]']: { alignSelf: 'start', color: 'coolGrey.80' },
    [mqMin.tabletLandscape]: {
      textAlign: 'left',
      gridTemplateColumns: '1fr 38%',
      gridTemplateRows: 'auto auto 45px auto',
      alignItems: 'center',
      gridTemplateAreas: `
      "heading heading"
      "image subheading"
      "image link"
      "image text"
      `,
      columnGap: 's80',
      ['[data-hero-role="heading"]']: { textAlign: 'center', marginBottom: 's64' },
      ['[data-hero-role="subheading"]']: { alignSelf: 'end', padding: '0' },
      ['[data-hero-role="link"]']: { margin: '0' },
    },
  },
  topSubLeft: {
    ...sharedBase,
    ...sharedStackedElements,
    ...topSubSharedStacked,
    ['[data-hero-role="link"]']: { margin: '0 auto' },
    ['[data-hero-role="text"]']: { color: 'coolGrey.80' },
    [mqMin.tabletLandscape]: {
      textAlign: 'left',
      gridTemplateColumns: '1fr 28%',
      gridTemplateRows: 'auto 1fr auto auto',
      gridTemplateAreas: `
      "subheading heading"
      "image heading"
      "image link"
      "image text"
      `,
      columnGap: 's40',
      ['[data-hero-role="heading"]']: { alignSelf: 'end' },
      ['[data-hero-role="link"]']: { margin: '0' },
    },
  },
  topSubRight: {
    ...sharedBase,
    ...sharedStackedElements,
    ...topSubSharedStacked,
    ['[data-hero-role="link"]']: { margin: '0 auto' },
    ['[data-hero-role="text"]']: { color: 'coolGrey.80' },
    [mqMin.tabletLandscape]: {
      textAlign: 'right',
      gridTemplateColumns: '28% 1fr',
      gridTemplateRows: 'auto 1fr auto auto',
      gridTemplateAreas: `
      "heading subheading"
      "heading image"
      "link image"
      "text image"
      `,
      columnGap: 's40',
      ['[data-hero-role="heading"]']: { alignSelf: 'end' },
      ['[data-hero-role="subheading"]']: { textAlign: 'left' },
      ['[data-hero-role="link"]']: { marginRight: '0' },
    },
  },
};

const gridHero: Util.VariantKeyModes<GridHeroVariantsType> = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export type GridHeroVariantsType = 'loweredSub' | 'topSubLeft' | 'topSubRight';
export const gridHeroVariants = Object.keys(base) as GridHeroVariantsType[];

export default gridHero;
